import { useState } from 'react';
import '../css/UiDesignSettings.css';
import '../css/BrowserPromptSettings.css';
import FacebookBrowserModal from './FacebookBrowserModal';
import FacebookBrowserModalV1 from './FacebookBrowserModalV1';
import { resolveBrowserPromptOption } from '../utils/browserPromptUtil';
import {
  BROWSER_PROMPT_OPTIONS,
  BROWSER_PROMPT_VERSIONS,
  BROWSER_PROMPT_SETTINGS_TITLE,
  BROWSER_PROMPT_SETTINGS_DESC,
  BROWSER_PROMPT_PREVIEW_LABEL,
} from '../constants/bookingConst';

/**
 * Config -> Theme -> Open in Browser Popup: which popup Facebook / Messenger
 * guests see, with a button that opens the selected version for real (in
 * preview mode, so its buttons never leave the admin screen).
 *
 * Edits only the form — nothing reaches guests until Save Configuration and a
 * redeploy, and the save is where the change is written to the audit trail.
 * Laid out like the UI Design section above it (UiDesignSettings.css).
 *
 * @param {object} props
 * @param {string|undefined} props.value - formData.browserPromptVersion
 * @param {(next: string) => void} props.onChange - receives the picked version value
 * @returns {JSX.Element}
 */
function BrowserPromptSettings({ value, onChange }) {
  const [previewOpen, setPreviewOpen] = useState(false);
  const selected = resolveBrowserPromptOption(value);
  const closePreview = () => setPreviewOpen(false);

  return (
    <div className="uid-section">
      <h3 className="uid-title">{BROWSER_PROMPT_SETTINGS_TITLE}</h3>
      <p className="uid-desc">{BROWSER_PROMPT_SETTINGS_DESC}</p>

      <div className="uid-body">
        <div className="uid-field">
          <label className="uid-label" htmlFor="bps-version-select">Version</label>
          <select
            id="bps-version-select"
            className="uid-select"
            value={selected.value}
            onChange={(e) => onChange(e.target.value)}
          >
            {BROWSER_PROMPT_OPTIONS.map(option => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
          <p className="uid-option-desc">{selected.description}</p>
        </div>

        <button type="button" className="bps-preview" onClick={() => setPreviewOpen(true)}>
          {BROWSER_PROMPT_PREVIEW_LABEL}
        </button>
      </div>

      {previewOpen && (selected.value === BROWSER_PROMPT_VERSIONS.V2
        ? <FacebookBrowserModal preview onClose={closePreview} />
        : <FacebookBrowserModalV1 onClose={closePreview} onOpen={closePreview} />
      )}
    </div>
  );
}

export default BrowserPromptSettings;
